module.exports = __webpack_public_path__ + "img/Search.b325aa84.svg";